export default "__VITE_ASSET__D9N2zXo1__"